import { numberScopes } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/fields/number.tsx';
import { commonIssueViewGranularScopes } from './fields-scopes.tsx';

export const originalEstimateIssueViewScopes = {
	...numberScopes,
	granular: [...numberScopes.granular, ...commonIssueViewGranularScopes],
};
